<template>
  <TextInput
    :value="teamFullSize"
    class="w-auto substitutes-count-input"
    disabled
    type="text"
    size="3"
    :label="
      $t('_web_tournament_settings_team-final-size-label', 'Total roster size')
    "
    :tooltip="
      $t(
        '_web_tournament_settings_team-final-size-help',
        'squad size + substitutes'
      )
    "
  />
</template>

<script>
import { mapGetters } from 'vuex';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentFullTeamSizeSetting',
  components: {
    TextInput,
  },
  mixins: [translate('_web_tournament_settings')],
  computed: {
    ...mapGetters(['currentTournament']),
    squadSize() {
      return this.$lodash
        .get(this.currentTournament, 'players_config.squad_size', '')
        .toString();
    },
    substitutesCount() {
      return this.$lodash.get(
        this.currentTournament,
        'players_config.max_substitutes',
        0
      );
    },
    teamFullSize() {
      return +this.squadSize + +this.substitutesCount;
    },
  },
};
</script>
